var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup7302(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1224,
    height: 896,
    viewBox: "0 0 1224 896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_164",
    x: 353,
    y: 242,
    width: 388,
    height: 388,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#efefef"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_166",
    x: 600,
    y: 619,
    width: 201,
    height: 201,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#efefef"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_175",
    x: 920,
    y: 695,
    width: 201,
    height: 201,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#efefef"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_167",
    x: 369,
    y: 0,
    width: 195,
    height: 195,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#efefef"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_168",
    x: 657,
    y: 163,
    width: 234,
    height: 234,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#efefef"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_173",
    x: 965,
    y: 318,
    width: 234,
    height: 234,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#efefef"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_165",
    x: 122,
    y: 361,
    width: 197,
    height: 197,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#efefef"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_174",
    x: 45,
    y: 76,
    width: 156,
    height: 156,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#efefef"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7302",
    "data-name": "Group 7302",
    transform: "translate(-315 -2358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7298",
    "data-name": "Group 7298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7296",
    "data-name": "Group 7296",
    transform: "translate(1 59)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_169",
    "data-name": "Ellipse 169",
    cx: 71,
    cy: 70,
    rx: 71,
    ry: 70,
    transform: "translate(1396 2789)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_170",
    "data-name": "Ellipse 170",
    cx: 43,
    cy: 43,
    r: 43,
    transform: "translate(314 2773)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_172",
    "data-name": "Ellipse 172",
    cx: 43,
    cy: 43,
    r: 43,
    transform: "translate(1142 2355)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_171",
    "data-name": "Ellipse 171",
    cx: 134,
    cy: 134,
    r: 134,
    transform: "translate(585 2695)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 314, 2299)",
    filter: "url(#Ellipse_164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_164-2",
    "data-name": "Ellipse 164",
    transform: "translate(362 248)",
    fill: "#fff",
    stroke: "#929292",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 185,
    r: 185,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 185,
    r: 184.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 314, 2299)",
    filter: "url(#Ellipse_166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_166-2",
    "data-name": "Ellipse 166",
    transform: "translate(609 625)",
    fill: "#fff",
    stroke: "#929292",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 91.5,
    r: 91.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 91.5,
    r: 91,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 314, 2299)",
    filter: "url(#Ellipse_175)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_175-2",
    "data-name": "Ellipse 175",
    cx: 91.5,
    cy: 91.5,
    r: 91.5,
    transform: "translate(929 701)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 314, 2299)",
    filter: "url(#Ellipse_167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_167-2",
    "data-name": "Ellipse 167",
    transform: "translate(378 6)",
    fill: "#fff",
    stroke: "#929292",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 88.5,
    cy: 88.5,
    r: 88.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.5,
    cy: 88.5,
    r: 88,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 314, 2299)",
    filter: "url(#Ellipse_168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_168-2",
    "data-name": "Ellipse 168",
    transform: "translate(666 169)",
    fill: "#fff",
    stroke: "#929292",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 108,
    r: 108,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 108,
    r: 107.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 314, 2299)",
    filter: "url(#Ellipse_173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_173-2",
    "data-name": "Ellipse 173",
    transform: "translate(974 324)",
    fill: "#fff",
    stroke: "#929292",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 108,
    r: 108,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 108,
    r: 107.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 314, 2299)",
    filter: "url(#Ellipse_165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_165-2",
    "data-name": "Ellipse 165",
    transform: "translate(131 367)",
    fill: "#fff",
    stroke: "#929292",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 89.5,
    r: 89.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 89.5,
    r: 89,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 314, 2299)",
    filter: "url(#Ellipse_174)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_174-2",
    "data-name": "Ellipse 174",
    cx: 69,
    cy: 69,
    r: 69,
    transform: "translate(54 82)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "UX_Research",
    "data-name": "UX Research",
    transform: "translate(758 2746)",
    fontSize: 36,
    fontFamily: "PlayfairDisplay-Medium, Playfair Display",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "UX Research")), /*#__PURE__*/React.createElement("text", {
    id: "Wireframing",
    transform: "translate(946 3026)",
    fontSize: 24,
    fontFamily: "PlayfairDisplay-Medium, Playfair Display",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Wireframing")), /*#__PURE__*/React.createElement("text", {
    id: "UI_Design",
    "data-name": "UI Design",
    transform: "translate(728 2404)",
    fontSize: 24,
    fontFamily: "PlayfairDisplay-Medium, Playfair Display",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "UI Design")), /*#__PURE__*/React.createElement("text", {
    id: "Design_System",
    "data-name": "Design System",
    transform: "translate(1009 2586)",
    fontSize: 24,
    fontFamily: "PlayfairDisplay-Medium, Playfair Display",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Design System")), /*#__PURE__*/React.createElement("text", {
    id: "Animation",
    transform: "translate(1339 2741)",
    fontSize: 24,
    fontFamily: "PlayfairDisplay-Medium, Playfair Display",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Animation")), /*#__PURE__*/React.createElement("text", {
    id: "User_Flow",
    "data-name": "User Flow",
    transform: "translate(481 2766)",
    fontSize: 24,
    fontFamily: "PlayfairDisplay-Medium, Playfair Display",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "User Flow")), /*#__PURE__*/React.createElement("text", {
    id: "Idea",
    transform: "translate(414 2457)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "PlayfairDisplay-Medium, Playfair Display",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Idea")), /*#__PURE__*/React.createElement("text", {
    id: "Presentation",
    transform: "translate(1266 3102)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "PlayfairDisplay-Medium, Playfair Display",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Presentation")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup7302);
export default __webpack_public_path__ + "static/media/Group 7302.9dec9665e81a5ebf0dc765e45367f6b8.svg";
export { ForwardRef as ReactComponent };